import { Col, Container, Row } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { EmailPwdRestoreForm } from "../components/EmailPwdRestoreForm";

export const EmailPwdRestore = () => {
    const { language } = useParams();


    return (
    <Container fluid className="vh-90">
        <Row className="h-90">
        <Col md={6} className="d-flex" style={{padding: "0"} }>
            <img
            src="/ilustracio-craiteria.png"
            alt="Craiteria"
            style={{ width: '99%', height: '100%', objectFit: 'cover', backgroundColor: '#FFF' }}
            />
        </Col>
        <Col md={6} className="d-flex justify-content-center align-items-center">
            <div className="w-100" style={{ maxWidth: '360px' }}>
                <img
                    src="/logo-craiteria.svg"
                    alt="Craiteria"
                    style={{ width: '100%', }}
                />
                        <EmailPwdRestoreForm language={language!} />
                    </div>

        </Col>
        </Row>
    </Container>
    );
}